var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.page.id)?_c('share-link-setup',{attrs:{"link":_vm.page.share_link,"title":_vm.page.title,"loading":_vm.isLoading,"errors":_vm.errors},on:{"submit":function($event){return _vm.submitSetupData($event)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }